import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { AuthenticationService } from '@core/authentication';
import { LocalizationService } from '@core/services/localization';
import { BaseComponent } from '@core/utils';
import { environment } from '@environment';

@Component({
    selector: 'askemo-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends BaseComponent implements OnDestroy {
    private readonly authenticationService = inject(AuthenticationService);
    public title = 'askemo';
    public environment = environment;

    constructor() {
        const matIconRegistry = inject(MatIconRegistry);
        const localizationService = inject(LocalizationService);
        const sanitizer = inject(DomSanitizer);

        super();
        matIconRegistry.setDefaultFontSetClass('material-symbols-rounded');
        matIconRegistry.addSvgIcon('collapse_content', sanitizer.bypassSecurityTrustResourceUrl('assets/images/collapse_content.svg'));
        matIconRegistry.addSvgIcon('ai', sanitizer.bypassSecurityTrustResourceUrl('assets/images/AI.svg'));
        this.authenticationService.init(this.destroyed);
        localizationService.init();
        localizationService.setLanguageFromUserCulture();
    }
}
